
<template>
  <div
    v-bind="$attrs"
    class="overflow-hidden relative"
    :class="bgColor ?? 'bg-gray-400'"
  >
    <ImageBroken
      v-if="imageError"
      class="text-gray-200 opacity-50 h-full justify-center flex items-center"
      :size="72"
    />
    <template v-else>
      <CarvisSpinner
        v-if="!fullImgLoaded || loading"
        class="absolute z-[2] p-2 max-w-40 max-h-40 opacity-50 m-auto left-0 right-0 bottom-0 top-0"
      />
      <img
        v-if="lowResImgSrc"
        class="absolute w-full h-full"
        :class="{
          'object-contain': mode === 'keep-aspect',
          'object-cover': mode === 'square-cover' || mode === 'square-keep-aspect',
        }"
        :src="lowResImgSrc"
      >
      <div
        v-if="lowResImgSrc"
        class="absolute inset-0 backdrop-blur-xs"
      />
      <img
        v-if="highResImgSrc"
        class="absolute h-full w-full"
        :class="{
          'z-[1]': fullImgLoaded,
          'object-contain': mode !== 'square-cover',
          'object-cover': mode === 'square-cover',
        }"
        loading="lazy"
        :src="highResImgSrc"
        @load="fullImgLoaded = true"
        @onerror="internalImageError = true"
      >
    </template>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { computed, ref } from 'vue'
import ImageBroken from 'vue-material-design-icons/ImageBroken.vue'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  loading?: boolean
  lowResImgSrc?: string
  highResImgSrc: string | null
  imageError?: boolean
  bgColor?: string
  mode: 'square-keep-aspect' | 'square-cover' | 'keep-aspect'
}>()

const fullImgLoaded = ref(false)
const internalImageError = ref(props.imageError)
const imageError = computed(() => props.imageError || internalImageError.value)

watch(() => props.highResImgSrc, () => fullImgLoaded.value = false)
</script>
